import { useId } from 'react';
import type { BadgeId } from '@rw/shared';
import { BADGE_INFO, SPECIAL_COLORS, TIER_COLORS, isMultiTier } from './achievements';

/** A badge drawn as a hexagonal medal: the frame's metal shows the tier; locked badges are grey. */
export function BadgeMedal({ id, tier, size = 56 }: { id: BadgeId; tier: number; size?: number }) {
  const gid = useId();
  const locked = tier <= 0;
  const [light, dark] = locked
    ? ['#2a3644', '#141b24']
    : isMultiTier(id)
      ? TIER_COLORS[tier - 1]!
      : SPECIAL_COLORS;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      role="img"
      aria-hidden="true"
      className="shrink-0"
    >
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={light} />
          <stop offset="1" stopColor={dark} />
        </linearGradient>
      </defs>
      <polygon points="50,3 91,26.5 91,73.5 50,97 9,73.5 9,26.5" fill={`url(#${gid})`} />
      <polygon
        points="50,13 82,31.5 82,68.5 50,87 18,68.5 18,31.5"
        fill="#0a0e13"
        opacity={locked ? 0.85 : 0.78}
      />
      <text
        x="50"
        y="52"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="34"
        opacity={locked ? 0.3 : 1}
        style={locked ? { filter: 'grayscale(1)' } : undefined}
      >
        {BADGE_INFO[id].icon}
      </text>
      {!locked && isMultiTier(id) ? (
        <g>
          {Array.from({ length: tier }, (_, i) => (
            <circle key={i} cx={50 + (i - (tier - 1) / 2) * 9} cy="80" r="3" fill={light} />
          ))}
        </g>
      ) : null}
    </svg>
  );
}
